export const DARK_GREEN = '#022A1C';